import React from 'react';

import { useDnD } from '../../DnDContext';
import { ICON_MAPPER } from '../../config/icon-mapper';

export default function SearchItem({ type, title, bgColor }) {
  const Icon = ICON_MAPPER[type];
  const [_, setType] = useDnD();

  const onDragStart = (event, nodeType) => {
    setType(nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };
  if (Icon) {
    return (
      <div
        draggable
        onDragStart={(event) => onDragStart(event, type)}
        style={{ display: 'flex', alignItems: 'center', gap: 10 }}
        className="dndnode"
      >
        {Icon && <img src={Icon} alt={title} />}
        <li
          style={
            {
              // wordBreak: "normal",
            }
          }
        >
          {title}
        </li>
      </div>
    );
  }
  return (
    <li
      draggable
      onDragStart={(event) => onDragStart(event, type)}
      className="dndnode"
      style={{ backgroundColor: bgColor }}
    >
      {Icon && <img src={Icon} alt={title} />}
      {title}
    </li>
  );
}
